import { render, staticRenderFns } from "./classification-footer.vue?vue&type=template&id=2ca22d4e&"
import script from "./classification-footer.vue?vue&type=script&lang=js&"
export * from "./classification-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports